import React, { createContext, useContext, useState, useCallback } from 'react';

const DEFAULT_MESSAGE = 'Hola, tengo una consulta sobre MoraBioVet.';

const WhatsAppContext = createContext({
  message: DEFAULT_MESSAGE,
  estudio: null,
  setWhatsappMessage: () => {},
  setWhatsappEstudio: () => {},
  resetWhatsappMessage: () => {},
});

export const WhatsAppProvider = ({ children }) => {
  const [message, setMessage] = useState(DEFAULT_MESSAGE);
  const [estudio, setEstudio] = useState(null);

  const setWhatsappMessage = useCallback((msg) => {
    setMessage(msg || DEFAULT_MESSAGE);
  }, []);

  const setWhatsappEstudio = useCallback((est) => {
    setEstudio(est || null);
  }, []);

  const resetWhatsappMessage = useCallback(() => {
    setMessage(DEFAULT_MESSAGE);
    setEstudio(null);
  }, []);

  return (
    <WhatsAppContext.Provider
      value={{ message, estudio, setWhatsappMessage, setWhatsappEstudio, resetWhatsappMessage }}
    >
      {children}
    </WhatsAppContext.Provider>
  );
};

export const useWhatsApp = () => useContext(WhatsAppContext);
